import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@project/translate';

import { SpinnerFormControlComponent } from './spinner-form-control.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormElementsModule } from '@lib/ui';

@NgModule({
  declarations: [SpinnerFormControlComponent],
  imports: [CommonModule, TranslateModule, MatProgressSpinnerModule, FormElementsModule],
  providers: [],
  exports: [SpinnerFormControlComponent],
})
export class SpinnerFormControlModule {}
